// Uso básico:
// <Alert>Mensagem de erro</Alert>
// <Alert variant="success" role="status">Sucesso!</Alert>
// <Alert variant="warning" center={false} title="Atenção">...</Alert>

export default function Alert({
  variant = "danger",           // danger | warning | success | info | primary | secondary
  role = "alert",               // "alert" (erro) ou "status" (informativo/sucesso)
  center = true,                // centraliza horizontalmente
  title,                        // título opcional
  children,                     // conteúdo
  className = "",               // classes extras
  style = {},                   // estilos extras
}) {
  const containerClass = `d-flex ${center ? "justify-content-center" : ""} mt-4`;
  const alertClass = `alert alert-${variant} shadow-sm w-100 ${className}`.trim();
  const mergedStyle = { maxWidth: "720px", ...style };
  const ariaLive = role === "alert" ? "assertive" : "polite";

  return (
    <div className={containerClass} aria-live={ariaLive}>
      <div className={alertClass} role={role} style={mergedStyle}>
        {title && <div className="fw-semibold mb-1">{title}</div>}
        {children}
      </div>
    </div>
  );
}
